import { isNil } from 'lodash';
import React, { useCallback } from 'react';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { Colors } from '@shared/styles';

interface Props {
  checked: boolean;
  children?: React.ReactNode;
  onChange?: (newValue: boolean) => void;
}

export function Checkbox({ checked, children, onChange }: Props) {
  const handleChange = useCallback(() => {
    onChange?.(!checked);
  }, [checked, onChange]);

  const renderCheckbox = () => {
    return (
      <>
        {checked ? (
          <MBIconV2 name="check-box" color={Colors.v2.green} size={32} />
        ) : (
          <MBIconV2 name="check-box-empty" color={Colors.v2.green} size={32} />
        )}
        {children}
      </>
    );
  };

  return (
    <View row>
      {!isNil(onChange) && (
        <MBTouchableOpacity onPress={handleChange}>{renderCheckbox()}</MBTouchableOpacity>
      )}
      {isNil(onChange) && renderCheckbox()}
    </View>
  );
}
